import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/participants/upload',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ParticipantUploadContainer',
      './modules/participantUpload'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ParticipantUpload = require('./containers/ParticipantUploadContainer').default
      const actions = require('./modules/participantUpload')
      const reducer = require('./modules/participantUpload').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'participantUpload', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, ParticipantUpload)

    /* Webpack named bundle   */
    }, 'participantUpload')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ParticipantUpload/index.js